export default {
    padStr(padChar, desiredLen, str) {        
        let result = str
        if (padChar.length > 0 && desiredLen > str.length) {
            while(result.length < desiredLen)
                result = padChar + result
        }        
        return result
    },
    subStr(str, start, len) {
        if (typeof str != 'string' || start < 0 || len < 0)
            throw new Error('Invalid parameters in call to subStr')
        let end = start + len
        return str.substring(start, end)
    },
    isWhiteSpaceChar(c) {
        if (!c || c.length != 1)
            return false
        
        return c == ' ' || c == '\t' || c == '\n' || c == '\r'
    },
    isNullOrEmpty(s) {
        return (!s || s === '')
    },
    isNullOrWhiteSpace(s) {
        if (this.isNullOrEmpty(s))
            return true

        for(var i=0; i < s.length; i++)
            if (!this.isWhiteSpaceChar(s.charAt(i)))
                return false

        return true
    }
}